<div class="d-flex align-items-center mb-2">
    <span class="fa-2x fa-fw mr-2 text-link mt-3" [ngClass]="['QA', 'LANGUAGE'] | monIcons" aria-hidden="true"></span>
    <h2 class="font-weight-300 mb-0" translate>
        Language Validation
    </h2>
</div>

<!-- Warning message when language attribute is disabled -->
<div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row" *ngIf="!isLanguageAttributeEnabled" translate>
    Use language attribute is disabled for this domain, please activate it to use this module
</div>

<!-- Main content - only show when language attribute is enabled -->
<div *ngIf="isLanguageAttributeEnabled">
    <div class="card panel-monsido-card mt-2" *ngIf="languageMatchData">
        <div class="card-body">
            <table class="table table-hover table-fixed">
                <thead class="hidden">
                <tr>
                    <th class="col-13 col-lg-9">&nbsp;</th>
                    <th class="col-37 col-lg-39">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <span class="ml-2 fas fa-language fa-lg fa-fw mr-2" aria-hidden="true"></span>
                        <span translate>Declared language</span>
                    </td>
                    <td class="text-v-middle">
                        <span *ngIf="languageMatchData.declared_language !== ''" class="text-capitalize">
                            {{ languageMatchData.declared_language | languageDisplay }}
                        </span>
                        <span *ngIf="languageMatchData.declared_language === ''"
                              class="text-muted d-flex align-items-center">
                            <span class="fas fa-times-circle fa-lg mr-2"></span>
                            <span class="font-weight-bold" translate>No languages detected</span>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="ml-2 fas fa-search fa-lg fa-fw mr-2" aria-hidden="true"></span>
                        <span translate>Detected Languages</span>
                    </td>
                    <td class="text-v-middle">
                        <span class="text-capitalize">
                            {{ languageMatchData.detected_languages | languageDisplayArray }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="ml-2 fas fa-tags fa-lg fa-fw mr-2" aria-hidden="true"></span>
                        <span translate>Multi-language tag</span>
                    </td>
                    <td class="text-v-middle">
                        <!-- Updated to show True/False instead of Tagged/Not tagged -->
                        <span *ngIf="languageMatchData.tag_multi_language"
                              class="text-success d-flex align-items-center">
                            <span class="fas fa-check-circle fa-lg mr-2"></span>
                            <span class="font-weight-bold">Yes</span>
                        </span>
                        <span *ngIf="!languageMatchData.tag_multi_language"
                              class="text-muted d-flex align-items-center">
                            <span class="fas fa-times-circle fa-lg mr-2"></span>
                            <span class="font-weight-bold">No</span>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="ml-2 fas fa-exclamation-triangle fa-lg fa-fw mr-2" aria-hidden="true"></span>
                        <span translate>Language mismatch</span>
                    </td>
                    <td class="text-v-middle">
                        <span *ngIf="languageMatchData.tag_mismatched_language"
                              class="label label-warning">
                            <span class="fas fa-exclamation-triangle mr-1"></span>
                            <span translate>Mismatch detected</span>
                        </span>
                        <span *ngIf="!languageMatchData.tag_mismatched_language"
                              class="text-success">
                            <span class="fas fa-check mr-1"></span>
                            <span translate>Languages match</span>
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card panel-monsido-card mt-2" *ngIf="!languageMatchData && !isLoading">
        <div class="card-body text-center text-muted">
            <span class="fas fa-info-circle mr-2"></span>
            <span translate>No language match data available for this page</span>
        </div>
    </div>
    <div class="card panel-monsido-card mt-2" *ngIf="isLoading">
        <div class="card-body text-center">
            <span class="fas fa-spinner fa-spin mr-2"></span>
            <span translate>Loading language validation data...</span>
        </div>
    </div>
</div>
